import { UserCircleIcon, KeyIcon, TableCellsIcon, ShieldCheckIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../features/auth/authSlice';
import { ChangePasswordForm } from '../components/ChangePasswordForm';
import { TeableConfigForm } from '../components/TeableConfigForm';
import { MfaEnrollmentForm } from '../components/MfaEnrollmentForm';
import { ProfileAvatarUpload } from '../components/ProfileAvatarUpload';
import { useAppDispatch } from '../store/hooks';
import {
  refreshEffectivePlatformPermissions,
  selectPlatformPermissionsStatus,
} from '../features/platformPermissions/platformPermissionsSlice';
import { showToast } from '../components/ui/toast.utils';

export const PerfilPage = () => {
  const dispatch = useAppDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const permStatus = useSelector(selectPlatformPermissionsStatus);
  const refreshingPerms = permStatus === 'loading';

  const handleRefreshPermissions = async () => {
    try {
      await dispatch(refreshEffectivePlatformPermissions()).unwrap();
      showToast('Permisos del menú actualizados.', 'success');
    } catch {
      showToast('No se pudieron recargar los permisos. Intentá cerrar sesión y volver a entrar.', 'error');
    }
  };

  return (
    <div className='mx-auto max-w-3xl space-y-6 p-4 md:p-6'>
      <header className='space-y-1 border-b border-border pb-4'>
        <p className='text-xs font-medium uppercase tracking-wide text-muted-foreground'>Cuenta</p>
        <h1 className='text-2xl font-bold text-foreground'>Mi perfil</h1>
      </header>

      <div className='bg-card text-card-foreground p-6 rounded-lg shadow-sm border border-border space-y-4'>
        <div className='flex items-center gap-2 text-lg font-medium text-foreground'>
          <UserCircleIcon className='h-5 w-5 text-muted-foreground' />
          <span>Información</span>
        </div>
        <ProfileAvatarUpload />
        <div className='space-y-3 border-t border-border pt-4'>
          <div>
            <div className='text-sm text-muted-foreground'>Email</div>
            <div className='text-sm text-foreground font-medium'>{currentUser?.email || '—'}</div>
          </div>
          <div>
            <div className='text-sm text-muted-foreground'>Rol de plataforma</div>
            <div className='text-sm text-foreground font-medium'>{currentUser?.role || '—'}</div>
          </div>
        </div>
      </div>

      <div className='bg-card text-card-foreground p-6 rounded-lg shadow-sm border border-border space-y-3'>
        <div className='flex items-center gap-2 text-lg font-medium text-foreground'>
          <ArrowPathIcon className='h-5 w-5 text-muted-foreground' />
          <span>Permisos del menú</span>
        </div>
        <p className='text-sm text-muted-foreground'>
          Si el menú lateral no muestra los módulos esperados tras un cambio de permisos, recargá la
          configuración efectiva sin cerrar sesión.
        </p>
        <button
          type='button'
          className='btn btn-outline btn-sm'
          disabled={refreshingPerms}
          onClick={() => void handleRefreshPermissions()}
        >
          {refreshingPerms ? 'Recargando…' : 'Recargar permisos del menú'}
        </button>
      </div>

      <div className='bg-card text-card-foreground p-6 rounded-lg shadow-sm border border-border space-y-4'>
        <div className='flex items-center gap-2 text-lg font-medium text-foreground'>
          <TableCellsIcon className='h-5 w-5 text-muted-foreground' />
          <span>Configuración de Teable</span>
        </div>
        <TeableConfigForm />
      </div>

      <div className='bg-card text-card-foreground p-6 rounded-lg shadow-sm border border-border space-y-4'>
        <div className='flex items-center gap-2 text-lg font-medium text-foreground'>
          <ShieldCheckIcon className='h-5 w-5 text-muted-foreground' />
          <span>Autenticación de dos factores (MFA)</span>
        </div>
        <MfaEnrollmentForm />
      </div>

      <div className='bg-card text-card-foreground p-6 rounded-lg shadow-sm border border-border space-y-4'>
        <div className='flex items-center gap-2 text-lg font-medium text-foreground'>
          <KeyIcon className='h-5 w-5 text-muted-foreground' />
          <span>Cambiar contraseña</span>
        </div>
        <ChangePasswordForm />
      </div>
    </div>
  );
};
